import { QueryKeys } from 'types/dev';
import { URLs } from 'types/url';
import { urlSchema } from 'schemas/url';
import { useQuery } from '@tanstack/react-query';

async function getURLs(): Promise<URLs> {
  const result = await fetch('./config/urls.json');
  const data = await result.json();
  return urlSchema.parse(data);
}

export default function useURLs(): URLs | undefined {
  const { data: urls } = useQuery([QueryKeys.URLS], getURLs);
  return urls;
}
